if (!customElements.get('bb-hero-film')) {
  customElements.define('bb-hero-film', class extends HTMLElement {
    connectedCallback() {
      if (this.lifecycle) return;
      const media = this.querySelector('video');
      const button = this.querySelector('button');
      if (!media || !button) return;
      this.lifecycle = new AbortController();
      const { signal } = this.lifecycle;
      const preference = matchMedia('(prefers-reduced-motion: reduce)');
      const sync = () => {
        button.textContent = media.paused ? 'Play film ▷' : 'Pause film Ⅱ';
        button.setAttribute('aria-label', media.paused ? 'Play background film' : 'Pause background film');
      };
      // Keep the native poster and manual play control visible while Safari loads.
      // Waiting for canplay to reveal them can leave a blocked autoplay stranded.
      media.muted = true;
      media.defaultMuted = true;
      media.playsInline = true;
      media.preload = 'auto';
      const poster = this.querySelector('.film-background > img');
      if (poster) media.poster = poster.currentSrc || poster.src;
      media.classList.add('film-ready');
      button.hidden = false;
      sync();
      const applyPreference = () => {
        media.autoplay = !preference.matches;
        if (preference.matches) media.pause();
        else void media.play().catch(sync);
      };
      const ready = () => { media.classList.add('film-ready'); button.hidden = false; sync(); };
      media.addEventListener('canplay', ready, { signal });
      media.addEventListener('play', sync, { signal });
      media.addEventListener('pause', sync, { signal });
      media.addEventListener('error', () => {
        media.classList.remove('film-ready');
        button.hidden = false;
        button.textContent = 'Retry film ▷';
        button.setAttribute('aria-label', 'Retry background film');
      }, { signal });
      button.addEventListener('click', () => {
        if (media.error) {
          media.classList.add('film-ready');
          media.load();
        }
        if(media.paused)void media.play().catch(sync);else media.pause();
      }, { signal });
      preference.addEventListener('change', applyPreference, { signal });
      if (media.readyState >= 3) ready();
      applyPreference();
    }
    disconnectedCallback() {
      this.lifecycle?.abort();
      this.lifecycle = undefined;
      this.querySelector('video')?.pause();
    }
  });
}
